<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <vs-popup classContent="popup-example" title="Update User" :active.sync="popup">
          <template>
          <ul class="centerx">
            <li>
              <vs-radio color="success" v-model="selected" vs-value="freecredit">Free 50 credit</vs-radio>
            </li>
            <!-- <li>
              <vs-radio color="success" v-model="adminsend" vs-value="adminsend">แอดมินใจดีแจก 50 เหรียญ</vs-radio>
            </li>
            <li>
              <vs-radio color="success" v-model="selectedmenu" vs-value="resetmenu">Show Menu แจ้งฝากแจ้งถอน</vs-radio>
            </li> -->
            <li>
              <vs-radio color="success" v-model="selected" vs-value="resetpassword">Reset Password</vs-radio>
            </li>
          </ul>
          </template>
          <br>
          <vs-button color="primary" type="filled" @click="updateUser">Save</vs-button>&nbsp;&nbsp;&nbsp;
          <vs-button color="dark" type="filled" @click="closePopup">Close</vs-button>
        </vs-popup>
        <vs-popup classContent="popup-example" title="Share Friend" :active.sync="popup2">
          <template>
            <v-select label="code" v-model="userId" :options="userOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </template>
          <br>
          <vs-button color="primary" type="filled" @click="updateUser2">Save</vs-button>&nbsp;&nbsp;&nbsp;
          <vs-button color="dark" type="filled" @click="closePopup2">Close</vs-button>
        </vs-popup>
        <vs-popup classContent="popup-example" :title="userCredit.code" :active.sync="popupcredit">
          <template>
            <div class="vx-row">
              <div class="vx-col sm:w-1/3 w-full mb-2">
                {{userCredit.code}}
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input class="w-full" label="Wallet" v-model="userCredit.credit"/>
              </div>
            </div>
            <div class="vx-row" v-for="(item,index) in sites" :key="index">
              <div class="vx-col sm:w-1/3 w-full mb-2" v-if="userCredit[index] && index==='lunarbet'">
                ln2f356{{userCredit[index].code.toLowerCase()}}
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2" v-else-if="userCredit[index]">
                {{userCredit[index].code}}
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2" v-if="userCredit[index]">
                <vs-input class="w-full" :label="item.name" v-model="userCredit[index].credit"/>
              </div>
            </div>
          </template>
          <br>
          <vs-button color="dark" type="filled" @click="closePopupCredit">Close</vs-button>
        </vs-popup>
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <!--vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="Add()">
                <span class="flex items-center">
                  <feather-icon icon="UserPlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Add</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="Delete()">
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>>

            </vs-dropdown-menu>
          </!--vs-dropdown-->
      </div>


      <!-- AgGrid Table floatingFilter="true"-->
      <!--:onGridReady="onGridReady" -->
      <p v-if="memberLoading" role="status" class="mt-4">กำลังโหลดข้อมูลลูกค้า...</p>
      <div v-if="memberError" role="alert" class="mt-4">{{ memberError }} <vs-button @click="retryMembers" size="small">ลองอีกครั้ง</vs-button></div>
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :pinnedBottomRowData="pinnedBottomRowData"
        >
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
// Store Module
const axios = require('axios').default;
// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererPromotion from './cell-renderer/CellRendererPromotion.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import CellRendererCreateDate from './cell-renderer/CellRendererCreateDate.vue'
import CellRendererBank from './cell-renderer/CellRendererBank.vue'
import CellRendererWeb from './cell-renderer/CellRendererWeb.vue'
import CellRendererCredit from './cell-renderer/CellRendererCredit.vue'
import moment from "moment-timezone";
import firebase from '@/services/saleData'
import 'firebase/database'
import 'firebase/firestore'
import { createHelpers } from 'vuex-map-fields'
const { mapFields } = createHelpers({
  getterType: `userManagement/getField`,
  mutationType: `userManagement/updateField`,
});
export default {
  beforeDestroy () { this._memberRequest++; this.$store.dispatch('userManagement/invalidateUsers'); },
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererPromotion,
    CellRendererVerified,
    CellRendererActions,
    CellRendererCreateDate,
    CellRendererBank,
    CellRendererWeb,
    CellRendererCredit,
  },
  // beforeMount() {
  //   this.getRowStyle = (params) => {
  //     if (params.node.rowPinned) {
  //       return { 'font-weight': 'bold' };
  //     }
  //   };
  //   this.pinnedBottomRowData = this.createData(1, 'Bottom');
  // },
  data () {
    return {
      memberLoading: true, memberError: '',
      remark:'',
      userId:'',
      selected: '',
      selectedmenu: '',
      adminsend:'',
      songkran:'',
      // Filter Options
      roleFilter: { label: 'All', value: 'all' },
      roleOptions: [
        { label: 'All', value: 'all' },
        { label: 'Admin', value: 'admin' },
        { label: 'User', value: 'user' },
        { label: 'Staff', value: 'staff' }
      ],

      statusFilter: { label: 'All', value: 'all' },
      statusOptions: [
        { label: 'All', value: 'all' },
        { label: 'Active', value: 'active' },
        { label: 'Deactivated', value: 'deactivated' },
        { label: 'Blocked', value: 'blocked' }
      ],

      isVerifiedFilter: { label: 'All', value: 'all' },
      isVerifiedOptions: [
        { label: 'All', value: 'all' },
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],

      departmentFilter: { label: 'All', value: 'all' },
      departmentOptions: [
        { label: 'All', value: 'all' },
        { label: 'Sales', value: 'sales' },
        { label: 'Development', value: 'development' },
        { label: 'Management', value: 'management' }
      ],

      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {
        suppressContextMenu:true,
        // onCellEditingStopped: (event) => {
        //   if(event.column.colId === 'firstname' || event.column.colId === 'lastname' || event.column.colId === 'bank' || event.column.colId === 'account_no' || event.column.colId === 'status' || event.column.colId === 'bonus'){
        //     this.$store.dispatch('userManagement/updateFieldUsers',{key:event.data.key,value:event.value,column:event.column.colId}).catch(err => { console.error(err) })
        //   }
        // }
      },
      pinnedBottomRowData: null,
      defaultColDef: {
        flex: 1,
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: 'รหัสสมาชิก',
          field: 'code',
          width: 200,
          filter: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'IP',
          field: 'ip',
          filter: true,
          width: 50
        },
        {
          headerName: 'เบอร์โทร',
          field: 'tel',
          filter: true,
          width: 150
        },
        {
          headerName: 'ชื่อ',
          field: 'firstname',
          filter: true,
          width: 150
        },
        {
          headerName: 'นามสกุล',
          field: 'lastname',
          filter: true,
          width: 150
        },
        {
          headerName: 'ธนาคาร',
          field: 'bank',
          filter: true,
          width: 100,
          cellRendererFramework: 'CellRendererBank',
          cellEditor: 'agSelectCellEditor',
          cellEditorParams: { values: ['truewallet','bankokbank','kbank','scb','krungsri','tisco','ttb','ktb','gsb','kiatnakin','uob','lh','ธนาคารอิสลาม','ghbank','cimb','baac','icbc','standard'] },
        },
        {
          headerName: 'เลขบัญชีธนาคาร',
          field: 'account_no',
          filter: true,
          width: 150
        },
        {
          headerName: 'เครดิตคงเหลือ',
          field: 'credit',
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererCredit'
        },
        {
          headerName: 'เพื่อนที่แนะนำ',
          field: 'userFriendCode',
          filter: true,
          width: 150
        },
        {
          headerName: 'วันที่สมัคร',
          field: 'createdate',
          filter: true,
          width: 100,
          cellRendererFramework: 'CellRendererCreateDate'
        },
        {
          headerName: 'ใช้งานล่าสุด',
          field: 'lastlogin',
          filter: true,
          width: 100,
          cellRendererFramework: 'CellRendererCreateDate'
        },
        {
          headerName: 'เปิด-ปิดเกมส์ลูกค้า',
          field: 'web',
          filter: true,
          width: 200,
          cellRendererFramework: 'CellRendererWeb'
        },
        {
          headerName: 'รับโปร',
          field: 'bonus',
          filter: true,
          width: 100,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'สถานะ',
          field: 'status',
          filter: true,
          width: 100,
          cellRendererFramework: 'CellRendererStatus'
        },
        // {
        //   headerName: 'แก้ไขข้อมูล',
        //   field: 'transactions',
        //   width: 150,
        //   cellRendererFramework: 'CellRendererActions'
        // }
      ],

      // Cell Renderer Components
      components: {
        CellRendererCreateDate,
        CellRendererBank,
        CellRendererLink,
        CellRendererStatus,
        CellRendererPromotion,
        CellRendererVerified,
        CellRendererActions,
        CellRendererWeb,
        CellRendererCredit
      }
    }
  },
  watch: {
    roleFilter (obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }
  },
  computed: {
    ...mapFields([
        'popup',
        'popup2',
        'popupcredit'
    ]),
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    userOption(){
      return this.$store.state.userManagement.userOption
    },
    usersData () { return this.memberLoading || this.memberError ? [] : this.$store.state.userManagement.users },
    userSelect () {
      return this.$store.state.userManagement.user_select
    },
    userSelect2 () {
      return this.$store.state.userManagement.user_select2
    },
    sites () {
      return this.$store.state.userManagement.sites
    },
    userCredit () {
      return this.$store.state.userManagement.usercredit
    },
    userOldCredit () {
      return this.$store.state.userManagement.useroldcredit
    },

    paginationPageSize () {
      //if (this.gridApi) return this.gridApi.paginationGetPageSize() else
      return 100
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    async retryMembers () {
      const request = this._memberRequest = (this._memberRequest || 0) + 1;
      this.memberLoading = true; this.memberError = '';
      try { await this.$store.dispatch('userManagement/fetchUsers'); }
      catch (_) { if (this._memberRequest === request) this.memberError = 'โหลดข้อมูลลูกค้าไม่สำเร็จ กรุณาลองอีกครั้ง'; }
      finally { if (this._memberRequest === request) this.memberLoading = false; }
    },
    onGridReady(params){
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
        window.onresize = () => {
            this.gridApi.sizeColumnsToFit();
        }
    },
    confirmDeleteRecord (data) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${data}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    async deleteRecord () {
      for(const data of this.gridApi.getSelectedRows()){
        const emailKey = data.email.trim().replace(/\./g, '||');
        await firebase.database().ref().child(`users/${emailKey}`).remove();
      }
      this.showDeleteSuccess()
      this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    },
    Add(){
      this.$router.push('/management/user/form')
    },
    Delete(){
      if(this.gridApi.getSelectedRows().length){
        let text = ''
        for(const data of this.gridApi.getSelectedRows()){
          text += (text)?', '+data.firstname:data.firstname
        }
        this.confirmDeleteRecord(text);
      }
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    async updateUser(){
      this.$store.commit('userManagement/SET_POPUP', false);
      // if(this.songkran){
      //   axios({
      //     method: "get",
      //     url: "https://api.ufaeasy888.com/songkran/"+this.userSelect.userId,
      //   });
      //   this.songkran = '';
      // }else
      // if(this.adminsend){
      //   axios({
      //     method: "get",
      //     url: "https://api.ufaeasy888.com/adminsend/"+this.userSelect.userId,
      //   });
      //   this.selectedmenu = '';
      //   this.adminsend = '';
      // }else
      // if(this.selectedmenu === 'freecredit'){
      //   axios({
      //     method: "get",
      //     url: "https://api.ufaeasy888.com/freecredit/"+this.userSelect.userId,
      //   });
      //   this.selectedmenu = '';
      //   this.adminsend = '';
      // }else
      // if(this.selectedmenu){
      //   axios({
      //     method: "get",
      //     url: "https://api.ufaeasy888.com/genrichmenu/"+this.userSelect.userId,
      //   });
      //   this.selectedmenu = '';
      //   this.adminsend = '';
      // }else{
      //   axios({
      //     method: "post",
      //     url: "https://api.ufaeasy888.com/resetpassword",
      //     data: {
      //       id: this.userSelect.key,
      //     }
      //   });
      //   this.selected = '';
      // }
      if(this.selected === 'freecredit'){
        let check = false;
        await firebase.firestore().collection('promotion').where('code','==',this.userSelect.code).where('promotion','==','credit free').limit(1).get().then((result)=>{
          if(result.size){
            check = true;
          }
        });
        if(!check){
          await axios({
            method: "get",
            url: "https://api.xxmac.co/api/freecredit/50/"+this.userSelect.key,
          }).then(async (result)=>{
            if(result && result.data && result.data.status){
              await firebase.firestore().collection('promotion').add({
                credit:50,
                promotion:'credit free',
                code:this.userSelect.code,
                userkey:this.userSelect.key,
                createdate:moment().tz("Asia/Bangkok").format('YYYY-MM-DD HH:mm:ss'),
                employee:this.activeUserInfo,
              })
              await firebase.firestore().collection('historyCredit').add({
                  createdate:moment().tz("Asia/Bangkok").format('YYYY-MM-DD HH:mm:ss'),
                  code:this.userSelect.code,
                  credit:50,
                  status:true,
                  type:'addcredit',
                  promotion:'creditfree',
                  employee:this.activeUserInfo.email,
              });
              this.$vs.notify({
                color: 'success',
                title: 'Add Credit',
                text: 'เพิ่มเครดิตฟรีเรียบร้อยแล้ว'
              })
            }else{
              this.$vs.notify({
                color: 'danger',
                title: 'Add Credit',
                text: 'ไม่สามารถเพิ่มเครดิตฟรีได้'
              })
            }
          });
        }else{
          this.$vs.notify({
            color: 'danger',
            title: 'Add Credit',
            text: 'รับเครดิตฟรีไปแล้ว'
          })
        }
      }else if(this.selected === 'resetpassword'){
        await axios({
          method: "post",
          url: "https://api.xxmac.co/api/resetpassword",
          data:{
            key:this.userSelect.key,
            password:this.userSelect.tel+'xxmac'
          }
        }).then(async (result)=>{
          if(result && result.data && result.data.status){
            this.$vs.notify({
              color: 'success',
              title: 'Reset password',
              text: 'reset password เรียบร้อยแล้ว'
            })
          }
        });
      }
      this.selected = '';
      /*.then(async response => {
       
      }).catch(function() {
        
      });*/
       
    },
    async updateUser2(){
      if(this.userSelect2 && this.userSelect2.key && !this.userSelect2.userFriendId && this.userId.code){
        firebase.database().ref(`users/${this.userSelect2.key}`).update({
          userFriendId:this.userId.code,
        }).then(()=>{
          const data = this.usersData;
          for(const x in data){
            if(data[x].key === this.userSelect2.key){
              data[x].userFriendCode = this.userId.code;
              break;
            }
          }
          this.$store.commit('userManagement/SET_USERS', data);
          this.$vs.notify({
            color: 'success',
            title: 'Add Friend',
            text: 'The selected user was successfully'
          })
        });
      }
      this.$store.commit('userManagement/SET_POPUP2', false);
    },
    closePopup(){
       this.$store.commit('userManagement/SET_POPUP', false);
    },
    closePopup2(){
       this.$store.commit('userManagement/SET_POPUP2', false);
    },
    closePopupCredit(){
      this.$store.commit('userManagement/SET_POPUPCREDIT', false);
    },
    async updateUserCredit(key){
      if(this.remark === '' || !this.remark){
        alert('โปรดระบุเหตุผล');
        return;
      }
      if(this.userCredit.key){
          axios({
            method: "post",
            url: "https://api.xxmac.co/api/setcredit",
            data: {
              web: key,
              key: this.userCredit.key,
              amount:(key === 'credit')?Number(this.userCredit.credit):this.userCredit[key].credit,
              oldamount:(key === 'credit')?Number(this.userOldCredit.credit):this.userOldCredit[key].credit,
              employee:this.activeUserInfo.firstname,
              remark:this.remark
            }
          }).then((result)=>{
            if(result && result.data && result.data.status){
              firebase.firestore().collection('setcredit').add({
                key: this.userCredit.key,
                code: this.userCredit.code,
                amount:(key === 'credit')?Number(this.userCredit.credit):this.userCredit[key].credit,
                oldamount:(key === 'credit')?Number(this.userOldCredit.credit):this.userOldCredit[key].credit,
                employee:this.activeUserInfo,
                remark:this.remark,
                createdate:moment().tz("Asia/Bangkok").format('YYYY-MM-DD HH:mm:ss'),
              });
              this.$vs.notify({
                color: 'success',
                title: `กำหนดเครดิต`,
                text: `กำหนดเครดิตจำนวน ${Number(this.userCredit[key].credit)} ให้ ${this.userCredit.code} เรียบร้อยแล้ว`
              })
              this.$store.commit('userManagement/SET_POPUPCREDIT', false);
            }else{
              this.$vs.notify({
                color: 'danger',
                title: `Error กำหนดเครดิต`,
                text: `ไม่สามารถกำหนดเครดิตจำนวน ${Number(this.userCredit[key].credit)} ให้ ${this.userCredit.code} เรียบร้อยแล้ว`
              })
              this.$store.commit('userManagement/SET_POPUPCREDIT', false);
            }
            this.remark = '';
          });
      }
    },
    createData(count, prefix) {
      var result = [];
      for (var i = 0; i < count; i++) {
        result.push({
          codeold: prefix + ' Age ' + i,
          ip: prefix + ' Country ' + i,
          firstname: prefix + ' Year ' + i,
          lastname: prefix + ' Date ' + i,
          bank: prefix + ' Date ' + i,
          account_no: prefix + ' Sport ' + i,
          coins: prefix + ' Sport ' + i,
          userFriendCode: prefix + ' Sport ' + i,
          createdate: prefix + ' Sport ' + i,
          lastlogin: prefix + ' Sport ' + i,
          ball: prefix + ' Sport ' + i,
          calculate: prefix + ' Sport ' + i,
          transactions: null,
        });
      }
      return result;
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if(window.innerWidth>1000)
    setTimeout( ()=> this.gridApi.sizeColumnsToFit(), 0 );
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () { this.retryMembers(); }
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
